/*!

=========================================================
* Argon Dashboard React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from 'react';
import utils from '../../utils.js';
import AccountSwitcher from '../AccountSwitcher';

// reactstrap components
import {
  Card,
  CardBody,
  CardTitle,
  Container,
  Row,
  Col,
  Badge,
  Alert,
  Button,
} from 'reactstrap';
import { Redirect } from 'react-router-dom';

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isCheckoutFilledOut: true,
      areProductsTracked: true,
      showJoinDiscord:
        utils.getCookies()[utils.SHOW_JOIN_DISCORD_COOKIE_NAME] !== '1',
    };
  }

  async componentDidMount() {}

  renderRedirect() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />;
    }
  }

  renderErrors() {
    if (this.props.user && !this.props.user.discordWebhook) {
      return (
        <Row>
          <Col lg="6" xl="3">
            <Alert className="mt-2" color="danger">
              Please go to the Notification Setup tab and enter your Discord
              webhook. Refresh to clear this message.
            </Alert>
          </Col>
        </Row>
      );
    }
  }

  renderStreamStatus() {
    let statusMsg = 'Waiting...';
    let className = 'bg-warning';
    let ping;

    return (
      <div style={{ marginBottom: '5px' }}>
        <Badge
          color=""
          className="badge-dot mr-4"
          style={{ paddingTop: '0px', paddingBottom: '0px' }}
        >
          <div className="h2 font-weight-bold mb-0">
            <i
              className={className}
              style={{ height: '0.5rem', width: '0.5rem' }}
            />
            {statusMsg}
          </div>
        </Badge>
        <div className="">Ping: {ping ? `${ping}ms` : 'calculating...'}</div>
      </div>
    );
  }

  hideShowJoinDiscord(e) {
    if (e) e.preventDefault();
    utils.setCookie(utils.SHOW_JOIN_DISCORD_COOKIE_NAME, '1');
    this.setState({
      showJoinDiscord: false,
    });
  }

  renderAccountSwitch() {
    return (
      <Row>
        <Col lg="6" xl="3">
          <AccountSwitcher {...this.props} />
        </Col>
      </Row>
    );
  }

  renderNotice() {
    return (
      <Row className="mb-4">
        <Col lg="8" xl="5">
          <Card className="card-stats mb-4 mb-xl-0">
            <CardBody style={{ paddingBottom: '11px' }}>
              <Row>
                <div className="col">
                  <CardTitle
                    tag="h5"
                    className="text-uppercase text-muted mb-0 text-orange"
                  >
                    ⚠️ NOTICE
                  </CardTitle>
                  <div className="font-weight-bold mb-0">
                    <div>
                      Logins may take longer than usual (several hours) because
                      our login system is processing a big backlog of accounts
                      that are re-logging in to refresh their session. We will
                      increase login server capacity in the near future. Thanks
                      for your patience!
                    </div>
                  </div>
                </div>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    );
  }

  renderJoinDiscord() {
    if (!this.state.showJoinDiscord) return null;
    return (
      <Row className="mb-4">
        <Col lg="8" xl="5">
          <Card className="card-stats mb-4 mb-xl-0">
            <CardBody style={{ paddingBottom: '11px' }}>
              <Row>
                <div className="col">
                  <CardTitle
                    tag="h5"
                    className="text-uppercase text-muted mb-0"
                  >
                    WELCOME!
                  </CardTitle>
                  <div className="font-weight-bold mb-0">
                    <div>
                      <b>DO THIS FIRST:</b> Join the{' '}
                      {this.props.getDiscordInviteLink()} so you can take part
                      in the community and get help. Then set up SnailBot by{' '}
                      <a href="https://docs.snailbot.io" target="_blank">
                        following the docs
                      </a>{' '}
                      (pw: snailgang).
                    </div>
                    <Badge
                      color="info"
                      href="#"
                      onClick={(e) => this.hideShowJoinDiscord(e)}
                    >
                      I Did It
                    </Badge>
                  </div>
                </div>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    );
  }

  render() {
    return (
      <>
        {this.renderRedirect()}
        {/*<div*/}
        {/*  className="header pb-8 pt-5 pt-md-8 easeload"*/}
        {/*  style={{*/}
        {/*    backgroundImage:*/}
        {/*      "url('https://source.unsplash.com/1600x900/?night')",*/}
        {/*    backgroundSize: 'cover',*/}
        {/*    backgroundRepeat: 'no-repeat',*/}
        {/*  }}*/}
        {/*>*/}
        <div className="header bg-gradient-info pb-8 pt-5 pt-md-8">
          <Container fluid>
            <div className="header-body">
              {/*{this.renderNotice()}*/}
              {this.renderJoinDiscord()}
              {this.renderAccountSwitch()}
              {this.renderErrors()}
            </div>
          </Container>
        </div>
      </>
    );
  }
}

export default Header;
